import React from 'react';
import { whatsappUrl } from '../lib/site';

export const WhatsAppIcon = ({ className = 'h-5 w-5' }) => (
  <svg viewBox="0 0 32 32" className={className} fill="currentColor" aria-hidden="true">
    <path d="M16.04 3C8.86 3 3.03 8.82 3.03 16c0 2.29.6 4.53 1.74 6.5L3 29l6.68-1.75A12.95 12.95 0 0 0 16.04 29C23.2 29 29 23.18 29 16S23.2 3 16.04 3zm0 23.8c-2.04 0-4.04-.55-5.78-1.6l-.41-.24-3.96 1.04 1.06-3.86-.27-.4A10.73 10.73 0 0 1 5.3 16c0-5.93 4.82-10.75 10.74-10.75S26.78 10.07 26.78 16 21.96 26.8 16.04 26.8zm5.89-8.05c-.32-.16-1.91-.94-2.2-1.05-.3-.11-.51-.16-.73.16-.21.32-.83 1.05-1.02 1.27-.19.21-.37.24-.7.08-.32-.16-1.36-.5-2.59-1.6-.96-.85-1.6-1.9-1.79-2.22-.19-.32-.02-.5.14-.66.15-.14.32-.37.48-.56.16-.19.21-.32.32-.53.11-.21.05-.4-.03-.56-.08-.16-.73-1.75-1-2.4-.26-.63-.53-.54-.73-.55h-.62c-.21 0-.56.08-.86.4-.3.32-1.13 1.1-1.13 2.69s1.16 3.12 1.32 3.33c.16.21 2.28 3.48 5.52 4.88.77.33 1.37.53 1.84.68.77.25 1.48.21 2.03.13.62-.09 1.91-.78 2.18-1.53.27-.75.27-1.4.19-1.53-.08-.13-.29-.21-.62-.37z" />
  </svg>
);

// Green "WhatsApp" button for the top bar: opens a chat with Romeo with a
// quote request already typed. Hidden until the site has his number.
const WhatsAppButton = ({ compact = false }) => {
  const href = whatsappUrl();
  if (!href) return null;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Message Paint It Better on WhatsApp"
      className={`flex items-center gap-2 rounded-full bg-[#25D366] text-white shadow-md hover:bg-[#1ebe5b] transition-colors ${
        compact ? 'p-2.5' : 'h-9 px-5 text-sm font-medium'
      }`}
    >
      <WhatsAppIcon className={compact ? 'h-6 w-6' : 'h-4 w-4'} />
      {!compact && <span>WhatsApp</span>}
    </a>
  );
};

export default WhatsAppButton;
